import { Directive, inject, OnInit } from "@angular/core";
import { Tooltip } from "primeng/tooltip";

@Directive({
    selector: "[kno2Tooltip]",
    hostDirectives: [
        {
            directive: Tooltip,
            inputs: ["pTooltip: kno2Tooltip", "tooltipDisabled", "tooltipPosition"]
        }
    ]
})
export class TooltipDirective implements OnInit {
    private readonly tooltip = inject(Tooltip);

    public ngOnInit(): void {
        this.tooltip.setOption({ tooltipPosition: this.tooltip.tooltipPosition || "top" });
    }
}
